var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ent-sign" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "box-wrap" },
        [
          _vm.defalutChapter
            ? _c("div", { staticClass: "temone" }, [
                _c("div", { staticClass: "t-box" }, [
                  _c("img", {
                    staticClass: "y-img",
                    attrs: {
                      src:
                        "data:image/jpeg;base64," + this.defalutChapter.signName
                    }
                  })
                ]),
                _c("p", { attrs: { title: "系统图形章" } }, [
                  _vm._v("系统图形章")
                ])
              ])
            : _vm._e(),
          _vm._l(_vm.chapterList, function(item, index) {
            return _c("div", { key: index, staticClass: "temone" }, [
              _c("div", { staticClass: "t-box" }, [
                item.defaultChapter && item.defaultChapter === 1
                  ? _c("img", {
                      staticClass: "mr-label",
                      attrs: { src: "/images/web/icon-default.png" }
                    })
                  : _vm._e(),
                _c("img", {
                  staticClass: "y-img",
                  attrs: { src: item.signUrl, title: item.signName }
                }),
                _c("div", { staticClass: "msk" }, [
                  !(item.defaultChapter && item.defaultChapter === 1)
                    ? _c(
                        "span",
                        {
                          staticClass: "setmr-btn",
                          on: {
                            click: function($event) {
                              return _vm.setDefaultSeal(item.signId)
                            }
                          }
                        },
                        [_vm._v("设为默认\n          ")]
                      )
                    : _vm._e(),
                  _c("span", {
                    staticClass: "el-icon-edit-outline",
                    staticStyle: { "margin-top": "1px" },
                    attrs: { title: "修改" },
                    on: {
                      click: function($event) {
                        return _vm.openFileUploadDialog(item)
                      }
                    }
                  }),
                  _c("span", {
                    staticClass: "el-icon-delete",
                    attrs: { title: "删除" },
                    on: {
                      click: function($event) {
                        return _vm.delChapter(item.signId)
                      }
                    }
                  })
                ])
              ]),
              _c(
                "p",
                {
                  attrs: { title: item.signName + "(ID:" + item.signId + ")" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(item.signName + "(ID:" + item.signId + ")") +
                      "\n      "
                  )
                ]
              ),
              _vm.userType
                ? _c(
                    "div",
                    { staticClass: "switch-style" },
                    [
                      _c("span", [_vm._v("打开后该印章可授权给成员 ")]),
                      _c("switch-button", {
                        attrs: { object: item },
                        on: { confirmFn: _vm.allowToUse },
                        model: {
                          value: item.corpSealId,
                          callback: function($$v) {
                            _vm.$set(item, "corpSealId", $$v)
                          },
                          expression: "item.corpSealId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          }),
          _c(
            "el-popover",
            {
              attrs: { placement: "right", width: "200" },
              model: {
                value: _vm.addVisible,
                callback: function($$v) {
                  _vm.addVisible = $$v
                },
                expression: "addVisible"
              }
            },
            [
              _c(
                "div",
                { staticClass: "popover-style" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.openFileUploadDialog }
                    },
                    [_vm._v("本地上传")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.addVisible = !_vm.addVisible
                          _vm.onLineVise = !_vm.onLineVise
                        }
                      }
                    },
                    [_vm._v("在线制作")]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "temone add",
                  attrs: { slot: "reference" },
                  slot: "reference"
                },
                [_c("span", { staticClass: "el-icon-plus" })]
              )
            ]
          )
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          staticClass: "ent-dialog",
          attrs: {
            title: "上传签章",
            visible: _vm.isAddSign,
            "close-on-click-modal": false,
            width: "550px"
          },
          on: {
            closed: _vm.handleDialogClosed,
            "update:visible": function($event) {
              _vm.isAddSign = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "entForm",
              staticClass: "ent-form",
              attrs: { model: _vm.chapterParam, rules: _vm.signNameRules }
            },
            [
              _c("el-form-item", [
                _c(
                  "div",
                  { staticClass: "upload-sign" },
                  [
                    _vm.chapterParam.signUrl
                      ? _c("img", { attrs: { src: _vm.chapterParam.signUrl } })
                      : [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _c("label", [_vm._v("点击上传签章图片")])
                        ],
                    _c("input", {
                      attrs: { type: "file", accept: "image/png" },
                      on: { change: _vm.handleInputChange }
                    })
                  ],
                  2
                )
              ]),
              _c(
                "el-form-item",
                { attrs: { prop: "signName" } },
                [
                  _c("el-input", {
                    attrs: { maxLength: "15", placeholder: "签章名称" },
                    model: {
                      value: _vm.chapterParam.signName,
                      callback: function($$v) {
                        _vm.$set(_vm.chapterParam, "signName", $$v)
                      },
                      expression: "chapterParam.signName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "text-left sign-tip" }, [
                _vm._v("\n        签章备注：\n        "),
                _c("ol", [
                  _c("li", [_vm._v("尺寸: 180 * 180px")]),
                  _c("li", [
                    _vm._v(
                      "\n            方法一：电脑使用PS，对签章抠图(去掉背景，存储为PNG格式)"
                    ),
                    _c("br"),
                    _vm._v("\n            方法二："),
                    _c(
                      "a",
                      {
                        attrs: {
                          target: "_blank",
                          href: "http://www.aigei.com/bgremover"
                        }
                      },
                      [_vm._v("透明处理链接")]
                    )
                  ])
                ])
              ]),
              _c(
                "p",
                { staticClass: "text-center btn" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.queryUploadInfo }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-child",
          attrs: {
            title: "签署配置",
            visible: _vm.dialogVisibleChild,
            "close-on-click-modal": false,
            width: "560px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisibleChild = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "child-list" },
            [
              _vm._l(_vm.chapterChildList, function(item, index) {
                return _vm.chapterChildList.length
                  ? [
                      _c(
                        "div",
                        { key: index, staticClass: "text-center list-item" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: item.ifUse,
                                callback: function($$v) {
                                  _vm.$set(item, "ifUse", $$v)
                                },
                                expression: "item.ifUse"
                              }
                            },
                            [_vm._v(_vm._s(item.sourceTag))]
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e()
              })
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "text-center footer-btn",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "success", size: "small" },
                  on: { click: _vm.queryChangeChildChapter }
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "danger", size: "small" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisibleChild = false
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ]
      ),
      _c("goto-auth", {
        attrs: { authDialog: _vm.authDialog },
        on: {
          "update:authDialog": function($event) {
            _vm.authDialog = $event
          },
          "update:auth-dialog": function($event) {
            _vm.authDialog = $event
          }
        }
      }),
      _c("sign-on-line", {
        attrs: { onLineVise: _vm.onLineVise },
        on: {
          viseControl: function($event) {
            _vm.onLineVise = !_vm.onLineVise
          },
          getChapterList: _vm.getChapterList
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "com-title com-ht" }, [
      _c("i"),
      _vm._v("我的印章")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-604a0180", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-604a0180","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tpl/entSign.vue
// module id = ZEzV
// module chunks = 134